// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3SEck","list":"PatternAutocomplete_list__WZAYx"};